import { combineReducers } from 'redux';
import { ReducerType } from '../types';
import { accountReducer } from './account';
import { customerAddressesReducer } from './addresses';
import { customerAllergensReducer } from './allergens';
import { customerCommunicationPrefsReducer } from './communicationPreferences';
import { customerCreditCardsReducer } from './creditCards';
import { customerFavoritesReducer } from './favorites';
import { customerFcmTokenReducer } from './fcmToken';
import { customerGiftCardsReducer } from './giftCards';
import { customerGroupOrdersReducer } from './groupOrders';
import { customerHistoryReducer } from './history';
import { customerHouseAccountsReducer } from './houseAccounts';
import { customerLoyaltyReducer } from './loyalty';
import { customerOrderReducer } from './order';
import { customerOrdersReducer } from './orders';
import { pointsShopReducer } from './pointsShop';
import { tplsPointsShopReducer } from './tplsPointsShop';
import { customerQRCodeReducer } from './qrCode';
import { customerRewardsReducer } from './rewards';
import { customerThanxReducer } from './thanx';
import { customerTplsReducer } from './tpls';
export const customerReducer = combineReducers({
    [ReducerType.Account]: accountReducer,
    [ReducerType.CommunicationPrefs]: customerCommunicationPrefsReducer,
    [ReducerType.CreditCards]: customerCreditCardsReducer,
    [ReducerType.CustomerAllergens]: customerAllergensReducer,
    [ReducerType.CustomerAddresses]: customerAddressesReducer,
    [ReducerType.Favorites]: customerFavoritesReducer,
    [ReducerType.FcmToken]: customerFcmTokenReducer,
    [ReducerType.GiftCards]: customerGiftCardsReducer,
    [ReducerType.GroupOrders]: customerGroupOrdersReducer,
    [ReducerType.History]: customerHistoryReducer,
    [ReducerType.HouseAccounts]: customerHouseAccountsReducer,
    [ReducerType.Loyalty]: customerLoyaltyReducer,
    [ReducerType.Order]: customerOrderReducer,
    [ReducerType.Orders]: customerOrdersReducer,
    [ReducerType.PointsShop]: pointsShopReducer,
    [ReducerType.TplsPointsShop]: tplsPointsShopReducer,
    [ReducerType.QRCode]: customerQRCodeReducer,
    [ReducerType.Rewards]: customerRewardsReducer,
    [ReducerType.Thanx]: customerThanxReducer,
    [ReducerType.Tpls]: customerTplsReducer
});
export * from './account';
export * from './addresses';
export * from './allergens';
export * from './communicationPreferences';
export * from './creditCards';
export * from './favorites';
export * from './fcmToken';
export * from './giftCards';
export * from './groupOrders';
export * from './history';
export * from './houseAccounts';
export * from './loyalty';
export * from './order';
export * from './orders';
export * from './pointsShop';
export * from './qrCode';
export * from './rewards';
export * from './thanx';
export * from './tpls';
export * from './tplsPointsShop';
